import React, { useState, useEffect } from 'react';
import xtend from 'xtend';

import QuickLook from './QuickLook';
import Metadata from './Metadata';
import Loader from '../../../common/components/notifications/Loader';
import QueryString from '../../../utils/QueryString';
import history from '../../../history';

export const useSetTab = () => {
    const [tab, setTab] = useState(QueryString.parse(history.location.search).tab || 'assets')
    useEffect(() => {
        if (QueryString.parse(history.location.search).tab || 'assets' !== tab) {
            setTab(QueryString.parse(history.location.search).tab)
        }
    }, [history.location.search])
    return [tab, setTab]
}

const ActiveEvent = props => {
    const [tab, setTab] = useSetTab()
    var metaActions = xtend(props.actions.metadata, {
        assets: props.actions.assets,
        transcript: props.actions.transcript,
        metamarkers: props.actions.metamarkers,
        miscAssetToEvent: props.actions.events.miscAssetToEvent,
        editEvent: props.actions.events.edit,
        publish: props.actions.events.publish,
        unpublish: props.actions.events.unpublish,
        player: props.actions.player,
        facebookLive: props.actions.facebookLive,
        streamTargets: props.actions.streamTargets,
        editKeywords: props.actions.editKeywords,
        restrictedDomains: props.actions.restrictedDomains,
        audioDescription: props.actions.audioDescription
    });
    if (props.loading) {
        return <Loader />
    }
    return (<div className="fullscreen-wrapper">
        <div className="event fullscreen">
            <QuickLook {...props}
                tab={tab}
                setTab={setTab}
                actions={props.actions.events}
                encoderActions={props.actions.encoders}
                isActive={true}
                ajaxState={props.ajaxState}
            />
            <Metadata {...props}
                tab={tab}
                setTab={setTab}
                clientID={props.clientID}
                actions={metaActions}
                data={props.metadata}
            />
        </div>
    </div>);
}

export default ActiveEvent;
